// extracted by mini-css-extract-plugin
export default {"Toggle":"Toggle__fIQv+","active":"active__t8NQa"};